import Hero from "../../components/landing/Hero";
import Features from "../../components/landing/Features";
import Choice from "../../components/landing/Choice";
import QuickLinks from "../../components/landing/QuickLinks";
import NewsletterForm from "../../components/landing/NewsletterForm";
import Footer from "../../components/landing/Footer";
import CTA from "../../components/landing/CTA";
import { useEffect } from "react";
import BannerImage from "../../components/landing/BannerImage";
import { useAppSelector } from "../../store/hooks";
export default function Home() {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  console.log(isAuthenticated);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white overflow-x-hidden">
      {/* Hero Section */}
      <div className="mt-0">
        <Hero />
      </div>

      {/* Features Section*/}
      <Features />

      {/* Choice Section */}
      <div className="mt-12 sm:mt-16 md:mt-20">
        <Choice />
      </div>

      {/* Banner Image Section */}
      <div className="mt-12 sm:mt-16 md:mt-20">
        <BannerImage />
      </div>

      {/* Quick Links Section */}
      <div className="mt-12 sm:mt-16 md:mt-20">
        <QuickLinks />
      </div>

      {/* Newsletter Section */}

      <div className="mt-12 sm:mt-16 md:mt-20">
        <NewsletterForm />
      </div>

      {/* CTA Section */}
      {!isAuthenticated && (
        <div className=" sm:mt-16 md:mt-20">
          <CTA />
        </div>
      )}

      {/* Footer */}
      <div className="mt-12 sm:mt-16 md:mt-20">
        <Footer />
      </div>
    </div>
  );
}
